/**
 * This service handles API interactions for the application.
 * Specifically, it provides methods to upload files and retrieve responses.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private readonly uploadApiUrl: string = "";

  constructor(
    private readonly http: HttpClient,
    private readonly envService: AppConfigService,
  ) {
    this.uploadApiUrl = envService.mmpUploadApiUrl;
  }

  uploadFiles(formData: FormData): Observable<any> {
    return this.http.post(this.uploadApiUrl, formData);
  }
}
